import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialTextFormat2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 6.1V1.52h-4.57v1.53H6.1V1.52H1.52V6.1h1.53v19.81H1.52v4.57H6.1v-1.53h19.81v1.53h4.57v-4.57h-1.53V6.1Zm-3.05 19.81h-1.52v1.52H6.1v-1.52H4.57V6.1H6.1V4.57h19.81V6.1h1.52Z\"/><path fill=\"currentColor\" d=\"M21.33 9.14h1.53v3.05h-1.53Z\"/><path fill=\"currentColor\" d=\"M10.67 7.62v1.52h4.57v13.72h-3.05v1.52h7.62v-1.52h-3.05V9.14h4.57V7.62zM9.14 9.14h1.53v3.05H9.14Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialTextFormat2
